<template>
  <el-date-picker
      v-model="value"
      :clearable="clearable"
      :editable="editable"
      :unlink-panels="true"
      end-placeholder="结束日期"
      format="yyyy-MM-dd"
      range-separator="至"
      start-placeholder="开始日期"
      style="width: 240px"
      type="daterange"
      value-format="yyyy-MM-dd"/>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "ZxxDateDomain",
  props: {
    editable: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: false
    },
    checkStart: {
      type: String,
      default: ""
    },
    checkEnd: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      value: [],
      dateStart: '',
      dateEnd: ''
    }
  },
  watch: {
    value(newVal) {
      if (newVal && newVal.length > 0) {
        if (newVal.length > 0) {
          this.$emit('update:checkStart', newVal[0]);
        }
        if (newVal.length > 0) {
          this.$emit('update:checkEnd', newVal[1]);
        }
      } else {
        this.$emit('update:checkStart', "");
        this.$emit('update:checkEnd', "");
      }
    }
  },
  async beforeMount() {
    this.value = [new Date().getFullYear() + '-01-01', new Date().getFullYear() + '-12-31']
  }
}
</script>
<style scoped>

</style>